import React, { useContext } from 'react';
import { RendererContext, RendererProvider } from 'react-fela';
import { styleRenderer } from './style-renderer';
var clientRenderer = styleRenderer({
  wrapHoverWithMediaHover: true
});
export function StyleProvider(_ref) {
  var _ref$renderer = _ref.renderer,
      renderer = _ref$renderer === void 0 ? clientRenderer : _ref$renderer,
      children = _ref.children;
  var contextRenderer = useContext(RendererContext);

  if (contextRenderer) {
    return children;
  }

  return /*#__PURE__*/React.createElement(RendererProvider, {
    renderer: renderer
  }, children);
}